import React from "react";
import "./TransLoader.css";

export default function TransLoader() {
  return (
    <div className="transloader-overlay">
      <div className="loader-wrapper">
        <div className="loader-ring"></div>
        <img
          src="/assets/TRADE_MARK_HD.png"
          alt="Company Logo"
          className="loader-logo"
        />
      </div>
    </div>
  );
}
